import { JOBS_LISTING_SEGMENT, JOBS_LISTING_SEGMENTS } from '../constants/url-constants';

/**
 * Whether a pathname is the SRP (locale root or jobs listing with optional filters).
 * Mirrors layout SRP detection — keep in sync with LayoutDefault / URL rewrites.
 *
 * Uses the shared JOBS_LISTING_SEGMENT(S) constants rather than a hand-rolled locale ternary:
 * sv's listing segment ('lediga-jobb') is NOT its job-DETAIL segment ('jobb',
 * LOCALIZED_PATHS.sv.job) — conflating the two by hand caused a real production bug
 * (2026-09-02) duplicated across 8 files. See url-constants.ts for the full story.
 */
export function isSearchPagePathname(path: string): boolean {
  const segments = String(path).split('/').filter(Boolean);
  if (segments.length === 0) return true;

  const [first, second] = [segments[0], segments[1]];
  const isLocale = ['en', 'fi', 'sv'].includes(first);

  if (isLocale && segments.length === 1) return true;

  if (isLocale) {
    const expected = JOBS_LISTING_SEGMENT[first as keyof typeof JOBS_LISTING_SEGMENT];
    if (second === expected) return true;
  }

  if (segments.length >= 1 && JOBS_LISTING_SEGMENTS.includes(first)) return true;

  return false;
}
